import React, { Component } from 'react'
import { Row, Col, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap'
import deleteImage from '../../../helpers/content/manageContent/deleteImage'
import { BeatLoader } from 'react-spinners'

class ImageInsertion extends Component {
  constructor(props) {
    super(props)

    this.textArea = React.createRef()
  }
  
  state = {
    imageWidth: 100,
    alignment: 'center',
    tagChanged: true,
    deleting: false,
    error: '',
    confirmDelete: false,
  }
  
// Alignment, Size, URL

  componentDidUpdate(prevProps) {
    const { activeImage } = this.props
    if (
      (prevProps.activeImage && prevProps.activeImage.id) !== 
      (activeImage && activeImage.id)
    ) {
      this.setState({tagChanged: true, confirmDelete: false})
    }
  }

  changeAlignment = ({target}) => this.setState({
    alignment: target.value, 
    tagChanged: true, 
    confirmDelete: false
  })

  changeWidth = ({target}) => this.setState({
    imageWidth: target.value, 
    tagChanged: true, 
    confirmDelete: false
  })

  delImage = () => {
    const { confirmDelete } = this.state
    if (!confirmDelete) return this.setState({confirmDelete: true}) 
    const { activeImage } = this.props
    const { id, path } = activeImage
    this.setState({deleting: true, error: ''})
    deleteImage(id, path)
      .then(() => this.setState({deleting: false}))
      .catch((error) => this.setState({deleting: false, error}))
  }

  copyToClipboard = (e) => {
    this.textArea.current.select()
    document.execCommand('copy')
    this.setState({tagChanged: false})
  }

  render() {
    const { changeAlignment, changeWidth, copyToClipboard, delImage } = this
    const { imageWidth, alignment, tagChanged, deleting, error, confirmDelete } = this.state
    const { activeImage } = this.props

    const center = alignment === 'center' ? ' text-center' : ''
    let tag = ''
    
    if (activeImage) {
      const imgString = `<img src='${activeImage.url}' class='img-fluid' />` 
      tag = `<div class='w-${imageWidth}${center}'>${imgString}</div>`
    }

    return (
      <Row>
        <Col xl='12'>
          <Form>
            <FormGroup row>
              <Label for='alignment' sm={2}>Alignment</Label>
              <Col sm={10}>
                <Input 
                  type='select'
                  value={alignment}
                  onChange={changeAlignment}
                  name='alignment'
                  id='alignment'
                >
                  <option value='center'>Center</option>
                  <option value='left'>Left</option>
                </Input>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for='imageWidth' sm={2}>Width</Label>
              <Col sm={10}>
                <Input
                  type='select'
                  value={imageWidth}
                  onChange={changeWidth}
                  name='imageWidth'
                  id='imageWidth'
                >
                  <option value={100}>100%</option>
                  <option value={75}>75%</option>
                  <option value={50}>50%</option>
                  <option value={25}>25%</option>
                </Input>
              </Col>
            </FormGroup>
          </Form>
        </Col>
        <Col xl='12'>
          <p>Insertion Tag:</p>
          <textarea ref={this.textArea} value={tag} cols={50} />
        </Col>
        <Col xl='12'>
          <Button
            disabled={!tag || !tagChanged}
            onClick={copyToClipboard}
          >
            {tagChanged ? 'Copy Tag' : 'Tag Copied'}
          </Button>
          <Button 
            color='danger' 
            disabled={!!deleting || !activeImage}
            onClick={delImage}
          >
            {deleting ? <BeatLoader loading={deleting} /> : (confirmDelete ? 'Are You Sure?' : 'Delete Image')}
          </Button>
          {error &&
            <Alert>{error}</Alert>
          }
        </Col>
      </Row>
    ) 
  }
}

export default ImageInsertion


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/ImageInsertion.js